import { render, staticRenderFns } from "./SeckillPreview.vue?vue&type=template&id=21c81f2d&scoped=true"
import script from "./SeckillPreview.vue?vue&type=script&lang=js"
export * from "./SeckillPreview.vue?vue&type=script&lang=js"
import style0 from "./SeckillPreview.vue?vue&type=style&index=0&id=21c81f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c81f2d",
  null
  
)

export default component.exports